// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  touch-action: none;
}

.fingerprint_control {
  display: flex;
  justify-content: center;
}

.fingerprint_control button {
  margin: 0 10px;
}

.finger path {
  transition: fill-opacity 0.5s;
  fill-opacity: 0;
  fill: limegreen;
}

.finger:hover path {
  fill-opacity: 1;
}

.selected path {
  fill-opacity: 1;
}

.damaged path {
  fill-opacity: 1;
  fill: yellow;
}

.amputated path {
  fill-opacity: 1;
  fill: red;
}

.scanned path {
  fill-opacity: 1;
  fill: aqua;
}

.fingerprint_message {
  height: -moz-fit-content;
  height: fit-content;
  margin: 10px auto;
  text-align: center;
}

.wsq path {
  fill-opacity: 1;
  fill: blueviolet;
}

.animate_action {
  display: none;
}

.animate {
  animation: pulse 0.75s infinite;
}
@keyframes pulse {
  70% {
    transform: translateY(-5%);
  }
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/fingerprint/fingerprint.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AACA;EACE,aAAA;EACA,uBAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,6BAAA;EACA,eAAA;EACA,eAAA;AAIF;;AAFA;EACE,eAAA;AAKF;;AAHA;EACE,eAAA;AAMF;;AAJA;EACE,eAAA;EACA,YAAA;AAOF;;AALA;EACE,eAAA;EACA,SAAA;AAQF;;AANA;EACE,eAAA;EACA,UAAA;AASF;;AAPA;EACE,wBAAA;EAAA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAUF;;AARA;EACE,eAAA;EACA,gBAAA;AAWF;;AATA;EACE,aAAA;AAYF;;AAVA;EACE,+BAAA;AAaF;AANA;EACE;IACE,0BAAA;EAcF;AACF","sourcesContent":[".container {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  touch-action: none;\n}\n.fingerprint_control {\n  display: flex;\n  justify-content: center;\n}\n.fingerprint_control button {\n  margin: 0 10px;\n}\n.finger path {\n  transition: fill-opacity 0.5s;\n  fill-opacity: 0;\n  fill: limegreen;\n}\n.finger:hover path {\n  fill-opacity: 1;\n}\n.selected path {\n  fill-opacity: 1;\n}\n.damaged path {\n  fill-opacity: 1;\n  fill: yellow;\n}\n.amputated path {\n  fill-opacity: 1;\n  fill: red;\n}\n.scanned path {\n  fill-opacity: 1;\n  fill: aqua;\n}\n.fingerprint_message {\n  height: fit-content;\n  margin: 10px auto;\n  text-align: center;\n}\n.wsq path {\n  fill-opacity: 1;\n  fill: blueviolet;\n}\n.animate_action {\n  display: none;\n}\n.animate {\n  animation: pulse 0.75s infinite;\n}\n@-webkit-keyframes pulse {\n  70% {\n    transform: translateY(-5%);\n  }\n}\n@keyframes pulse {\n  70% {\n    transform: translateY(-5%); \n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
